import en from './en'
import id from './id'
import my from './my'
import ph from './ph'
export default {
  en,
  id,
  my,
  ph
}